import React, { useState } from 'react';
import MyAccountScreenContext from 'contexts/MyAccountScreenContext';

import MyAccountScreen from './MyAccount';
import { MY_ACCOUNT_OPTIONS } from '../../propTypes/myAccountOptions';

const MyAccountScreenContainer = () => {
  const [selectedOption, setSelectedOption] = useState(
    MY_ACCOUNT_OPTIONS.PROFILE,
  );

  return (
    <MyAccountScreenContext.Provider
      value={{ selectedOption, setSelectedOption }}
    >
      <MyAccountScreen selectedOption={selectedOption} />
    </MyAccountScreenContext.Provider>
  );
};

export default MyAccountScreenContainer;
